import React from 'react';
import './GlWidgetTable.scss';
import { LatestAssetTrendDataPoint } from '../../services/dashboard/LatestAssetTrendDataService';

interface GlWidgetTableProps {
  data: LatestAssetTrendDataPoint[];
  rowsConfig: any[][];
  wellInfo: Record<string, any>;
}

const GlWidgetTable: React.FC<GlWidgetTableProps> = ({ data, rowsConfig, wellInfo }) => {
 
  const getValue = (row: any): string => {
    if (row.na) return '-';
    if (row.staticValue) {
      return String(row.staticValue).trim();
    }
    if (row.staticValueKey) {
      const val = wellInfo?.[row.staticValueKey];
      if (val !== undefined && val !== null) {
        const cleaned = String(val).trim();
        return cleaned.length > 0 ? cleaned : '-';
      }
      return '-';
    }

    if (row.calc === 'flowlineChokeDP') {
      const flowline = Number(data.find((d) => d.paramTypeId === '185')?.value);
      const tubing = Number(data.find((d) => d.paramTypeId === '9')?.value);
      return !isNaN(flowline) && !isNaN(tubing) ? (flowline - tubing).toFixed(2) : '-';
    }
    if (row.calc === 'deltaInjection') {
      const rate = Number(data.find((d) => d.paramTypeId === '191')?.value);
      const setpoint = Number(data.find((d) => d.paramTypeId === '200')?.value);
      return !isNaN(rate) && !isNaN(setpoint) ? (rate - setpoint).toFixed(2) : '-';
    }
    if (row.calc === 'injectionPath') {
      return wellInfo?.InjectionPath ?? '-';
    }
    if (row.paramTypeId) {
      const match = data.find((d) => d.paramTypeId === row.paramTypeId);
      return match?.value ?? '-';
    }
    return '-';
  };
  return (
    <div id='grid-item-gl-wellStatus' className='gl-status-fullwidth'>
      <main style={{ paddingLeft: '20px', marginTop: '6px' }}>
        <div>
          <table className='gl-widget-table'>
            <tbody>
              {rowsConfig.map((row, idx) => (
                <tr key={idx}>
                  {row.map((cell, i) => (
                    <React.Fragment key={i}>
                      <td className='gl-wt-label'>{cell.label}</td>
                      <td className='gl-wt-value'>{getValue(cell)}</td>
                    </React.Fragment>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
};

export default GlWidgetTable;
